import { get } from '../actions/method';

export async function getMobileConfigDetail(mobileConfigId) {
  return get(`app/mobileConfigurations/${mobileConfigId}`)
    .then((resp) => resp)
    .catch((err) => {
      throw err;
    });
}
